import React from 'react';
import InfoModalWidget_Landscape from './widgetInfoModal_landscape';
import InfoModalWidget_Potrait from './widgetInfoModal_potrait';
import { useSelector } from 'react-redux';
import { LANDSCAPE } from '../../config/Constant';

const InfoModalWidget = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));


    if (appOrientation == LANDSCAPE) {
        return <InfoModalWidget_Landscape {...props} />;
    } else {
        return <InfoModalWidget_Potrait {...props} />;
    }
};

export default InfoModalWidget;
